import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AgentDashboard from './pages/AgentDashboard';
import ModulePage from './pages/ModulePage';
import ExamPage from './pages/ExamPage';
import ResultsPage from './pages/ResultsPage';
import SupervisorDashboard from './pages/SupervisorDashboard';
import TrainerDashboard from './pages/TrainerDashboard';
import ChangePassword from './pages/ChangePassword';
import { CircularProgress, Box } from '@mui/material';

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
      <CircularProgress />
    </Box>
  );

  if (!user) {
    return (
      <Routes>
        <Route path='*' element={<Login />} />
      </Routes>
    );
  }

  if (user.role === 'agent') {
    return (
      <Routes>
        <Route path='/dashboard' element={<AgentDashboard />} />
        <Route path='/module/:moduleId' element={<ModulePage />} />
        <Route path='/exam/:templateId' element={<ExamPage />} />
        <Route path='/results' element={<ResultsPage />} />
        <Route path='/change-password' element={<ChangePassword />} />
        <Route path='*' element={<Navigate to='/dashboard' replace />} />
      </Routes>
    );
  }

  if (user.role === 'trainer' || user.role === 'admin') {
    return (
      <Routes>
        <Route path='/trainer' element={<TrainerDashboard />} />
        <Route path='/module/:moduleId' element={<ModulePage />} />
        <Route path='/change-password' element={<ChangePassword />} />
        <Route path='*' element={<Navigate to='/trainer' replace />} />
      </Routes>
    );
  }

  if (user.role === 'supervisor') {
    return (
      <Routes>
        <Route path='/supervisor' element={<SupervisorDashboard />} />
        <Route path='/change-password' element={<ChangePassword />} />
        <Route path='*' element={<Navigate to='/supervisor' replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path='*' element={<Login />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
